import React, { PureComponent} from "react";
import { branch } from "baobab-react/higher-order";
// import PropTypes from "baobab-react/prop-types";
import themes from "../../constants/themes";
import _ from "lodash";
import autoBind from "react-autobind";

import { showFixedValuesOverlay, hideFixedValuesOverlay } from "../../actions/playerActions";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

class FixedValuesPanel extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			showOverlay: false
		};
		autoBind(this);
	}

	handleShowOverlay() {
		showFixedValuesOverlay();
	}

	handleHideOverlay() {
		hideFixedValuesOverlay();
	}

	render() {

		const { fixedValues, stateVariables, overlayPanelMode, fixedValuesShowOverlay } = this.props;
		const theme = global.activityTheme ? global.activityTheme : themes[(this.props.nightMode) ? "nightMode" : "default"];
		// console.log("render fixed alues panel", fixedValues, stateVariables);
		let component = null;
		const variables = {};

		const _styles = !!theme.appBar.hideTitle && !!theme.appBar.hideMenuIcon ? stylesColumn : styles;
		if (stateVariables && _.isPlainObject(stateVariables)) {
			_.keys(stateVariables).forEach(key => {
				variables[key] = stateVariables[key].value;
			});
		}

		if (fixedValues && _.isArray(fixedValues) && stateVariables) {

			const children = [];
			let first = true;
			fixedValues.forEach((child, idx) => {
				
				const _variables = child.display.match(/\$\{(.+?)\}/g);

				console.log("Variables", _variables);

				if (_variables && _variables.length > 0) {
					// let hasAllRequiredVariables = false;
					let varCount = _variables.length;
					let foundVariables = 0;
					_variables.forEach(variable => {
						const rawVariable = variable.replace("${variables['", "").replace("']}", "").replace("${variables.", "").replace("}", "");
						if (variables.hasOwnProperty(rawVariable) && !_.isEmpty(variables[rawVariable])) {
							foundVariables++;
						}
					});
					if (foundVariables === varCount) {
						try {
							const resolvedValue = eval("`" + child.display + "`"); // eslint-disable-line no-eval
							let additonalProps = {};
							if (child.textStyles) {
								additonalProps.style = child.textStyles;
							}

							children.push(<div key={`fixed-value-${idx}`} style={first ? _styles.fixedValue : _styles.fixedValueNotFirst}><span {...additonalProps}>{resolvedValue}</span></div>);
							first = false;
						} catch (e) {
							children.push(<div key={`fixed-value-${idx}`} style={_styles.fixedValue}><span>{e.message}</span></div>);
						}
					} else {
						console.warn("Unable to render fixed value, missing some variables", _variables, variables);
					}
				}
			});

			let containerStyles = _.assign({}, { flexDirection: "column"}, _styles.container);

			if (children.length > 0) {
				if (overlayPanelMode) {
					if (fixedValuesShowOverlay) {
						component =
							<div style={{ position: "absolute", left: 0, top: 0, width: "100%", height: 150, backgroundColor: "rgba(255,255,255,.8)", zIndex: 5, overflowX: "hidden", overflowY: "auto" }}>
								{children}
							</div>;	
					}

				} else {
					component =
						<>
							<div className="content-fixed-values-full" style={containerStyles}>
								{children}
							</div>
							{!fixedValuesShowOverlay && <div onClick={this.handleShowOverlay} className="content-fixed-values-icon" style={containerStyles}>
								<FontAwesomeIcon icon={"info-square"} />
							</div>}
							{fixedValuesShowOverlay && <div onClick={this.handleHideOverlay} className="content-fixed-values-icon" style={containerStyles}>
								<FontAwesomeIcon icon={"times"} />
							</div>}
						</>;	
				}
			}
		} else {
			console.warn("No need to render fixed values panel", variables, stateVariables, fixedValues);
		}

		return component;
	}
}

const stylesColumn = {
	container: { display: "flex", width: "100%", flex: 1, alignItems:"flex-end", justifyContent:"center"},
	fixedValue: {
		padding: 10,
		paddingVertical: 5,
		justifyContent: "center",
	},
	fixedValueNotFirst: {
		padding: 10,
		paddingVertical: 5,
		justifyContent: "center",
		borderTopWidth: 1,
		borderTopColor: "lightgray",
		borderTopStyle: "solid"
	}
};

const styles = {
	container: { display: "flex", width: "100%", flex: 1, flexWrap: "wrap", flexDirection: "row", height:15 },
	fixedValue: {
		padding: 10,
		paddingVertical:5,
		justifyContent:"center",
	},
	fixedValueNotFirst: {
		padding: 10,
		paddingVertical: 5,
		justifyContent: "center",
		borderLeftWidth: 1,
		borderLeftColor: "lightgray",
		borderTopStyle: "solid"
	}
};
export default branch({
	fixedValues: ["activity", "authorProperties", "fixedValues"],
	stateVariables: ["activity", "variables"],
	nightMode: ["nightMode"],
	fixedValuesShowOverlay: ["appState", "fixedValues", "showOverlay"]
}, FixedValuesPanel);